import React from 'react';
import { textStyles } from '../../../constants/textStyles';
import Button from '../../../components/Button/Button';

/**
 * ÐÑÐ¾Ð³ÑÐµÑÑ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð±Ð°Ð½ÐºÐ¸.
 *
 * Ð Ð°Ð½ÑÑÐµ Ð½Ð° ÑÑÐ¾Ð¼ Ð¼ÐµÑÑÐµ ÐºÑÑÑÐ¸Ð»ÑÑ Ð±ÐµÑÐºÐ¾Ð½ÐµÑÐ½ÑÐ¹ ÑÐ¿Ð¸Ð½Ð½ÐµÑ: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð½Ðµ Ð¿Ð¾Ð½Ð¸Ð¼Ð°Ð», Ð¸Ð´ÑÑ
 * Ð»Ð¸ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ° Ð¸ ÑÐºÐ¾Ð»ÑÐºÐ¾ ÐµÑÑ Ð¶Ð´Ð°ÑÑ, Ð·Ð°ÐºÑÑÐ²Ð°Ð» Ð²ÐºÐ»Ð°Ð´ÐºÑ â Ð¸ ÑÐ´ÐµÐ»ÐºÐ° Ð¾ÑÑÐ°Ð²Ð°Ð»Ð°ÑÑ Ð½Ð°
 * ÑÐ°Ð³Ðµ Ð°Ð½ÐºÐµÑÑ. ÐÑÐ¾ÑÐµÐ½ÑÑ Ð·Ð´ÐµÑÑ Ð½Ðµ ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ: ÑÑÐ¸ÑÐ°ÐµÐ¼ Ð¿Ð¾ ÑÐ°ÐºÑÐ¸ÑÐµÑÐºÐ¸Ð¼ Ð¾ÑÐ²ÐµÑÐ°Ð¼
 * Ð±Ð°Ð½ÐºÐ¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐµ Ð±ÑÐºÐµÐ½Ð´ Ð¿Ð¾Ð¼ÐµÑÐ°ÐµÑ Ð² Ð·Ð°ÑÐ²ÐºÐµ ÑÑÐ°Ð·Ñ, ÐºÐ°Ðº Ð±Ð°Ð½Ðº Ð¾ÑÐ²ÐµÑÐ¸Ð».
 */

const STATE_TEXT = {
  accepted: 'Ð·Ð°ÑÐ²ÐºÐ° Ð¿ÑÐ¸Ð½ÑÑÐ°',
  failed: 'Ð½Ðµ Ð¿ÑÐ¸Ð½ÑÐ» Ð·Ð°ÑÐ²ÐºÑ',
  pending: 'Ð¶Ð´ÑÐ¼ Ð¾ÑÐ²ÐµÑâ¦',
};

const STATE_COLOR = {
  accepted: '#2FA84F',
  failed: '#C6280E',
  pending: '#8E8E93',
};

const rowText = { ...textStyles.fieldLabel, fontWeight: '400' };

const SendAppealProgress = ({ open, total, banks = [], error, onRetry, onClose }) => {
  if (!open) return null;

  const answered = banks.filter((i) => i.state !== 'pending').length;
  const percent = total > 0 ? Math.min(100, Math.round((answered / total) * 100)) : 0;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: 420,
          maxWidth: '90vw',
          maxHeight: '80vh',
          overflowY: 'auto',
          background: '#fff',
          borderRadius: 12,
          padding: 24,
          display: 'grid',
          gap: 16,
        }}
      >
        <p style={textStyles.formTitle}>
          {error ? 'ÐÑÐ¿ÑÐ°Ð²ÐºÐ° Ð½Ðµ Ð·Ð°Ð²ÐµÑÑÐ¸Ð»Ð°ÑÑ' : 'ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½ÐºÐ¸'}
        </p>

        {error ? (
          <p style={{ ...rowText, color: '#C6280E' }}>{error}</p>
        ) : (
          <>
            <div style={{ display: 'grid', gap: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={rowText}>
                  ÐÑÐ²ÐµÑÐ¸Ð»Ð¸ {answered} Ð¸Ð· {total}
                </span>
                <span style={rowText}>{percent}%</span>
              </div>
              <div style={{ height: 6, borderRadius: 3, background: '#EFEFF4' }}>
                <div
                  style={{
                    height: 6,
                    borderRadius: 3,
                    width: `${percent}%`,
                    background: '#2FA84F',
                    transition: 'width 0.3s ease',
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'grid', gap: 8 }}>
              {banks.map((item) => (
                <div
                  key={item.id}
                  style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}
                >
                  <span style={rowText}>{item.name}</span>
                  <span style={{ ...rowText, color: STATE_COLOR[item.state] }}>
                    {STATE_TEXT[item.state]}
                  </span>
                </div>
              ))}
            </div>

            <p style={{ ...rowText, fontSize: '14px', color: '#8E8E93' }}>
              ÐÐ°ÑÐ²ÐºÐ¸ ÑÐ¶Ðµ ÑÑÐ»Ð¸ Ð² Ð±Ð°Ð½ÐºÐ¸. ÐÐ°Ð¶Ðµ ÐµÑÐ»Ð¸ Ð·Ð°ÐºÑÑÑÑ Ð¾ÐºÐ½Ð¾, ÑÐ´ÐµÐ»ÐºÐ° Ð¿ÐµÑÐµÐ¹Ð´ÑÑ Ð½Ð° ÑÐ°Ð³
              Ñ Ð±Ð°Ð½ÐºÐ°Ð¼Ð¸ ÑÐ°Ð¼Ð°.
            </p>
          </>
        )}

        {error ? (
          <div style={{ display: 'flex', gap: 12 }}>
            {onRetry ? <Button fill text="ÐÐ¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÑ" onClick={onRetry} /> : null}
            <Button text="ÐÐ°ÐºÑÑÑÑ" onClick={onClose} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SendAppealProgress;
